import styled, { css } from "styled-components/macro"
import { IconButton, PrimaryButton, SearchableSelect } from "@humanpredictiveintelligence/myqvt-library"

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    padding: 32px 32px 0 32px;

    background-color: ${theme.colors.white};
    box-shadow: ${theme.shadows.main};

    ${TopSectionFilters} {
      @media print {
        display: flex;
        flex-direction: column;
      }
    }
  `}
`

export const TopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const TopSectionFilters = styled.div`
  flex-shrink: 1;
`

export const AttributeSelect = styled(SearchableSelect)`
  width: 225px;
  margin-bottom: 32px;

  &:not(:last-child) {
    margin-right: 32px;
  }
  
  ${({ defaultValues }) => css`
    @media print {
      display: ${defaultValues && defaultValues?.length < 1 ? "none" : "block"};
      width: 100%;
      margin-bottom: -2px;
    }
  `}
`

export const FiltersActions = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: calc(${({ theme }) => theme.typography.fontSizeLabelSmaller} + 8px);

  @media print {
    display: none;
  } 
`

export const FiltersAction = styled(IconButton)`
  &:not(:last-of-type) {
    margin-right: 16px;
  }
`

export const BottomSectionToggle = styled(PrimaryButton)`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 50%);

  @media print {
    display: none;
  }
`

export const BottomSection = styled.div<{ $isHidden: boolean }>`
  ${({ $isHidden }) => $isHidden && css`
    display: none;
  `}

  @media print {
    display: initial;
  }
`

export const PrintOnlyNoFiltersMessage = styled.span`
  display: none;
  
  @media print {
    display: block;
  }
`
